import { LoaderCircle } from 'lucide-react';

type SpinnerSize = 'sm' | 'md' | 'lg';
type SpinnerColor = 'default' | 'accent' | 'white';

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};

const colorClasses: Record<SpinnerColor, string> = {
  default: 'text-charcoal',
  accent: 'text-accent-green',
  white: 'text-white',
};

/**
 * @component LoadingSpinner
 * @description Animated spinner for loading states. Uses the Lucide LoaderCircle icon.
 * @param size - 'sm' (w-4), 'md' (w-6, default), 'lg' (w-8)
 * @param color - 'default' (charcoal), 'accent' (green), 'white'
 * @param className - Additional CSS classes.
 */
export default function LoadingSpinner({
  size = 'md',
  color = 'default',
  className = '',
}: {
  size?: SpinnerSize;
  color?: SpinnerColor;
  className?: string;
}) {
  return (
    <LoaderCircle
      className={`${sizeClasses[size]} ${colorClasses[color]} animate-spin ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}
